module.exports = "images/atheneum.jpg";